import React, { ReactNode } from 'react';
import { Placeholder } from 'react-bootstrap';
import { BackButton } from '../../../../../shared/components/button/BackButton';
import { priceSplitter } from '../../../../../utils/helpers/priceSplitter';
import { useTranslation } from 'react-i18next';

export interface IArchiveHeader {
    totalEarnings: number;
    outstandingEarnings: number;
    activeCampaigns: number;
    completedCampaigns: number;
}

interface IArchiveHeaderProps {
    invoicesTotals: IArchiveHeader;
    isLoading?: boolean;
}

// Jedan boks: vrijednost gore, labela dolje; dok traje učitavanje vrijednost je placeholder
const TotalBox = ({
    value,
    label,
    isLoading,
    isPrice = false,
}: {
    value: ReactNode;
    label: string;
    isLoading: boolean;
    isPrice?: boolean;
}) => (
    <div className="default-border-lighter default-radius p-2 mr-2 text-center w-50 w-md-auto">
        {isLoading ? (
            <div className="placeholder-glow mb-1" aria-hidden="true">
                <Placeholder className="skeleton skeleton-table-cell" />
            </div>
        ) : (
            <h6 className={`mb-0 text-primary ${isPrice ? 'euro-symbol' : ''}`}>{value}</h6>
        )}
        <p className="mb-0">{label}</p>
    </div>
);

const InvoiceArchiveHeader = ({ invoicesTotals, isLoading = false }: IArchiveHeaderProps) => {
    const { t } = useTranslation();

    return (
        <div className="d-md-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center mb-md-3">
                <BackButton />
                <h6 className="mb-0">{t('influencer.invoice.invoice_upload')}</h6>
            </div>
            <div className="d-md-flex">
                <div className="d-flex my-2 my-md-0">
                    <TotalBox
                        value={invoicesTotals?.activeCampaigns ?? 0}
                        label={t('influencer.invoice.active_camp')}
                        isLoading={isLoading}
                    />
                    <TotalBox
                        value={invoicesTotals?.completedCampaigns ?? 0}
                        label={t('influencer.invoice.completed_camp')}
                        isLoading={isLoading}
                    />
                </div>
                <div className="d-flex mb-3 mb-md-0">
                    <TotalBox
                        value={priceSplitter(invoicesTotals?.totalEarnings ?? 0)}
                        label={t('influencer.invoice.total_earnings')}
                        isLoading={isLoading}
                        isPrice
                    />
                    <TotalBox
                        value={priceSplitter(invoicesTotals?.outstandingEarnings ?? 0)}
                        label={t('influencer.invoice.outstanding_earnings')}
                        isLoading={isLoading}
                        isPrice
                    />
                </div>
            </div>
        </div>
    );
};

export default React.memo(InvoiceArchiveHeader);
